import TextTitleCondensed from 'components/TextTitleCondensed'
import React from 'react'

export default function TextCondensed (props) {
  return (
    <TextTitleCondensed
      fs='body'
      {...props}
    />
  )
}
